import Immutable from 'immutable'
import { types } from 'store/actions/courses'

const initialState = Immutable.fromJS({
  pending: false,
  dateLoaded: undefined,
  errors: new Immutable.List(),
  // allCourses: undefined,
})

export default function coursesReducer(state = initialState, action) {
  let ret = state
  const { type, payload } = action
  switch(type) {
    case `${types.GET_COURSES}_PENDING`: {
      ret = ret.set('pending', true)
      break
    }
    case `${types.GET_COURSES}_REJECTED`:
      ret = ret.set('pending', false)
        .set('dateLoaded', new Date())
        .update('errors', errors => errors.unshift({
          message: payload.message,
          date: new Date(),
        }))
      break
    case `${types.GET_COURSES}_FULFILLED`: {
      try {
        const coursesByUserCurriculumId = Immutable.fromJS(Object.entries(payload).reduce((acc, [_status, courses]) => {
          return acc.concat(courses)
        }, []))
          .reduce((acc, course) => {
            return acc.set(course.get('id'), course)
          }, new Immutable.Map())
        ret = ret.set('pending', false)
          .set('dateLoaded', new Date())
          .update('errors', errors => errors.clear())
          .set('allCourses', coursesByUserCurriculumId)
      } catch(err) {
        console.error(err)
        ret = ret.set('pending', false)
          .set('dateLoaded', new Date())
          .update('errors', errors => errors.unshift({
            message: err.message,
            date: new Date(),
          }))
      }
      break
    }
    default:
      // no default
  }
  return ret
}
